import React from 'react'
import Hero from '../components/Hero'

function Product() {
    return (
        <div>
            <Hero type={'other'}>Product</Hero>

            PRODUCT PAGE
        </div>
    )
}

export default Product